document.addEventListener('DOMContentLoaded', function () {
  let initialized = false;

  function initPredictiveSearch() {
    if (initialized) return;
    initialized = true;

    const searchDrawer = document.querySelector('.predictive-search_wrapper');
    const searchDrawerInner = document.querySelector('#search-drawer');
    const predictiveInput = document.querySelector('.header__search-bar.predictive-search.hidden-pocket');
    const closeButton = document.querySelector('[data-custom-close]');

    if (!searchDrawer || !searchDrawerInner || !predictiveInput) return;

    predictiveInput.addEventListener('click', function (e) {
      e.stopPropagation();
      searchDrawer.classList.add('is-active-search');
      searchDrawerInner.classList.add('is-active');
      searchDrawerInner.setAttribute('open', '');
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        closePredictiveDrawer();
      });
    }

    document.addEventListener('click', function (e) {
      if (searchDrawer.classList.contains('is-active-search')) {
        const clickedInside = searchDrawer.contains(e.target);
        if (!clickedInside) {
          closePredictiveDrawer();
        }
      }
    });

    function closePredictiveDrawer() {
      searchDrawer.classList.remove('is-active-search');
      searchDrawerInner.classList.remove('is-active');
      if (typeof searchDrawerInner.close === 'function') {
        searchDrawerInner.close();
      } else {
        searchDrawerInner.removeAttribute('open');
        requestAnimationFrame(() => {
          searchDrawerInner.classList.remove('is-active');
        });
      }
    }
  }

  function destroyPredictiveSearch() {
    initialized = false;
    const searchDrawer = document.querySelector('.predictive-search_wrapper');
    const searchDrawerInner = document.querySelector('#search-drawer');
    if (searchDrawer && searchDrawerInner) {
      searchDrawer.classList.remove('is-active-search');
      searchDrawerInner.classList.remove('is-active');
      searchDrawerInner.removeAttribute('open');
    }
  }

  if (window.innerWidth >= 769) {
    initPredictiveSearch();
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth >= 769 && !initialized) {
        initPredictiveSearch();
      } else if (window.innerWidth < 769 && initialized) {
        destroyPredictiveSearch();
      }
    }, 250);
  });
});
